export default "__VITE_ASSET__BUTpaBQ1__$_?component__"